import { render, staticRenderFns } from "./InfoDetail.vue?vue&type=template&id=61cc37df&"
import script from "./InfoDetail.vue?vue&type=script&lang=js&"
export * from "./InfoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports